import { Injectable } from '@angular/core';
import { API_ENDPOINT } from '@core/configs';
import { CreateHelpDTO } from '@core/models/dto/help.dto';
import { ApiService } from '../common/api.service';

@Injectable({
  providedIn: 'root',
})
export class HelpService {
  constructor(private readonly http: ApiService) {
  }

  getAll() {
    return this.http.get(
      API_ENDPOINT.help.controller + API_ENDPOINT.help.getAll,
    );
  }

  create(data: CreateHelpDTO) {
    const dto = this.prepareCreateHelpDTO(data);
    return this.http.post(
      API_ENDPOINT.help.controller,
      dto,
    );
  }

  update(data: CreateHelpDTO, id: number) {
    const dto = this.prepareCreateHelpDTO(data);
    return this.http.put(
      API_ENDPOINT.help.controller + id,
      dto,
    );
  }

  delete(id: number) {
    return this.http.delete(
      API_ENDPOINT.help.controller + id,
    );
  }

  createDraft(data: CreateHelpDTO) {
    const dto = this.prepareCreateHelpDTO(data);
    return this.http.post(
      API_ENDPOINT.help.controller + API_ENDPOINT.help.createDraft,
      dto,
    );
  }

  private prepareCreateHelpDTO(data: CreateHelpDTO): CreateHelpDTO {
    if (data.popupStartDateTime) {
      data.popupStartDateTime = new Date(new Date(data.popupStartDateTime).setHours(0, 0, 0, 0));
    }
    if (data.popupEndDatetime) {
      data.popupEndDatetime = new Date(new Date(data.popupEndDatetime).setHours(23, 59, 59, 99));
    }
    return data;
  }
}
